import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackRoutingModule } from './feedback.routing';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackService } from './feedback.service';
import { SharedModule } from 'app/shared/shared.module';
import { FeedbackComponent } from './feedback.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({ declarations: [FeedbackComponent], imports: [CommonModule,
        FeedbackRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        TableModule,
        ButtonModule,
        CardModule,
        TagModule,
        DialogModule,
        InputTextModule,
        TooltipModule], providers: [FeedbackService, provideHttpClient(withInterceptorsFromDi())] })
export class FeedbackModule { }
